import { TravelTicketDocMap } from '../../../../../types';
import Finger, { Status } from '../../../../atoms/finger';
import ChecklistSection from '../../../../atoms/checklist-section';
import { getVisible } from '../../../../../utilities/documents';
import { getFormatDateFromStoreDate } from 'shared-components';

interface IProps {
  documents: TravelTicketDocMap;
  openDocumentModal: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string,
    docKey: string,
    modalTitle: string,
    fileNames: string[],
    isComplete: boolean,
    biometricResidencePermit?: any
  ) => void;
}

export const TravelTicketDocs = (props: IProps) => {
  const { documents: docs, openDocumentModal } = props;

  if (!docs || Object.keys(docs).length === 0) {
    return null;
  }
  const visibleDocs = getVisible(docs, false);

  if (visibleDocs.length === 0) {
    return null;
  }

  const openModal = (data: { title: string; docKey: string; fileNames: string[]; isComplete: boolean }) => {
    openDocumentModal('beforeTravel', null, 'travelTicket', data.docKey, data.title, data.fileNames, data.isComplete);
  };

  const renderedDocs = visibleDocs.map(({ item, key: travelTicketKey }) => {
    const label = `Travel ticket or Booking for ${getFormatDateFromStoreDate((item as any).date)}`;
    switch (item.status) {
      case 'REJECTED': {
        return (
          <Finger
            key={`travel-ticket-${travelTicketKey}`}
            id={`travel-ticket-${travelTicketKey}`}
            hideButton={true}
            status={Status.Rejected}
            reason={item.reason}
            label={label}
          />
        );
      }
      case 'APPROVED':
      case 'UPLOADED_OK':
      case 'REPLACED': {
        return (
          <Finger
            key={`travel-ticket-${travelTicketKey}`}
            id={`travel-ticket-${travelTicketKey}`}
            status={Status.Complete}
            completeLabel={'Done'}
            label={label}
            onClick={() =>
              openModal({
                isComplete: true,
                fileNames: item.fileNames,
                docKey: travelTicketKey,
                title: label
              })
            }
          />
        );
      }
      default: {
        return (
          <Finger
            key={`travel-ticket-${travelTicketKey}`}
            id={`travel-ticket-${travelTicketKey}`}
            status={Status.InProgress}
            completeLabel={'Done'}
            label={label}
            onClick={() =>
              openModal({
                isComplete: false,
                fileNames: item.fileNames,
                docKey: travelTicketKey,
                title: label
              })
            }
          />
        );
      }
    }
  });

  return (
    <>
      <ChecklistSection label={`Upload a document that shows your travel to the UK`}>{renderedDocs}</ChecklistSection>
    </>
  );
};
